import { createSelector } from "reselect";

const stateBarsSelector = state => state.bars;

export const barsSelector = createSelector(
  [stateBarsSelector],
  bars => bars
);